import { render } from "./year.vue?vue&type=template&id=623d8658&scoped=true"
import script from "./year.vue?vue&type=script&lang=js"
export * from "./year.vue?vue&type=script&lang=js"

import "./year.vue?vue&type=style&index=0&id=623d8658&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-623d8658"

export default script